export enum ListViewFilterTagType {
  Count,
  DropdownWithoutTotalCount,
  Input,
  Date,
  Binary
}
